import React, { FormEvent, useContext, useEffect, useState } from "react";
import { RouteComponentProps } from "react-router";
import TextareaAutosize from "react-textarea-autosize";
import EmployeeStore from "../../../app/stores/employeeStore";
import { observer } from "mobx-react-lite";
import { Button, Dropdown, Form, Segment } from "semantic-ui-react";
import { IEmployee } from "../../../app/models/employee";

interface DetailParams {
  id: string;
}

const EmployeeEditForm: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history,
}) => {
  const employeeStore = useContext(EmployeeStore);
  const {
    loadEmployee,
    editEmployee,
    submitting,
    clearEmployee,
    employeesByName,
    jobpositionsByName,
  } = employeeStore;

  const [employee, setEmployee] = useState<IEmployee>({
    email: "",
    name: "",
    preferredName: "",
    company: "",
    status: "",
    department: "",
    position: "",
    qualified: "",
    projectType: "",
    mobile: "",
    address: "",
    dob: "",
    startDate: "",
    companyEmail: "",
    workerId: "",
    type: "",
    australianResidency: "",
    nbnEnableId: "",
    usi: "",
    photoUrl: "",
    remark: "",
  });

  const [open, setOpen] = useState(false);

  const projectList  = employeesByName.map((project) => {
    return project["projectType"];
  });

  const currentprojects = projectList.filter(function(item, pos) {
    if (item !== null) return projectList.indexOf(item) == pos;
  });

  const companyOptions = [
    { key: "Brighten Technologies", text: "Brighten Technologies", value: "Brighten Technologies" },
    { key: "Buffalo Innovation", text: "Buffalo Innovation", value: "Buffalo Innovation" },
  ];

  const typeOptions = [
    { key: "TFN", text: "TFN", value: "TFN" },
    { key: "ABN", text: "ABN", value: "ABN" },
    { key: "TFN+ABN", text: "TFN+ABN", value: "TFN+ABN" },
  ];

  const statusOptions = [
    { key: "Employee", text: "Employee", value: "Employee" },
    { key: "Subcontractor", text: "Subcontractor", value: "Subcontractor" },
    { key: "Inactive", text: "Inactive", value: "Inactive" },
    { key: "Resigned", text: "Resigned", value: "Resigned" },
    { key: "Blacklist", text: "Blacklist", value: "Blacklist" },
  ];
  
  const departOptions = [
    { key: "PMO", text: "PMO", value: "PMO" },
    { key: "IT&Cloud", text: "IT&Cloud", value: "IT&Cloud" },
    { key: "Technician", text: "Technician", value: "Technician" },
  ];

  const positionOptions = jobpositionsByName.map(function (pos) {
    var option = { "key": pos.id, "text": pos.name, "value": pos.name }
    return option;
  });
  
  const projectOptions = [
    { key: "Mobile", text: "Mobile", value: "Mobile" },
    { key: "Transmission", text: "Transmission", value: "Transmission" },
    { key: "Minor", text: "Minor", value: "Minor" },
    { key: "Rail", text: "Rail", value: "Rail" },
    { key: "Unify", text: "Unify", value: "Unify" },
    { key: "Others", text: "Others", value: "Others" },
  ];

  const residencyOptions = [
    { key: "PR", text: "PR", value: "PR" },
    { key: "Citzen", text: "Citizen", value: "Citizen" },
    {
      key: "Temporary Working Visa(485)",
      text: "Temporary Working Visa(485)",
      value: "Temporary Working Visa(485)",
    },
    { key: "Student(500)", text: "Student(500)", value: "Student(500)" },
  ];

  const [residency, setResidency] = useState(residencyOptions);

  useEffect(() => {
    loadEmployee(match.params.id).then(
      (employee) => setEmployee(employee)
    );
    return () => {
      clearEmployee();
    };
  }, []);

  const handleSubmit = () => {
    editEmployee(employee).then(() => history.push(`/hrmanagement/employees/${match.params.id}`));
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setEmployee({ ...employee, [name]: value });
  };

  return (
    <Segment clearing>
      <Form onSubmit={handleSubmit}>
        <Form.Group widths="equal">
          <Form.Input
            label="Employee Name"
            required
            onChange={handleInputChange}
            name="name"
            placeholder="Employee Name"
            value={employee.name}
          />
          <Form.Input
            label="Preferred Name"
            onChange={handleInputChange}
            name="preferredName"
            placeholder="Employee Preferred Name"
            value={employee.preferredName}
          />
          <Form.Dropdown
            label="Company"
            placeholder='Company'
            name="company"
            multiple
            required
            search
            selection
            onChange={(e, { name, value }) => {
              setEmployee({ ...employee, [name]: value });
            }}
            options={companyOptions}
            value={employee.company}
          />
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Input
            label="Employee Email"
            required
            onChange={handleInputChange}
            name="email"
            type="email"
            placeholder="Employee Email"
            value={employee.email}
          />
          <Form.Input
            label="Company Email"
            onChange={handleInputChange}
            name="companyEmail"
            type="email"
            placeholder="Company Email"
            value={employee.companyEmail}
          />
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Select
            label="Employement Status"
            required
            onChange={(e, { name, value }) =>
              setEmployee({ ...employee, [name]: value })
            }
            name="status"
            placeholder="Employee Status"
            value={employee.status}
            options={statusOptions}
          />
          <Form.Select
            label="Department"
            required
            onChange={(e, { name, value }) =>
              setEmployee({ ...employee, [name]: value })
            }
            name="department"
            placeholder="Employee Department"
            value={employee.department}
            options={departOptions}
          />
        </Form.Group>
        <Form.Group widths="equal">
        <Form.Select
            label="Position"
            required
            onChange={(e, { name, value }) =>
              setEmployee({ ...employee, [name]: value })
            }
            name="position"
            placeholder="Employee Position"
            value={employee.position}
            options={positionOptions}
          />
          {/* <Form.Dropdown 
            label="Project Type"
            placeholder='Project Type' 
            selection
            clearable
            name='Dropdown'
            labeled
            open={open}
            onFocus={() => setOpen(true)}
            onBlur={() => setOpen(false)}
            text={employee.projectType}
          >
          <Dropdown.Menu>
           <Dropdown.Header content='New Project Type' />
           <Form.Input 
             placeholder='Input new project type and press enter'
             onKeyDown={(e: any) => {
              if(e.keyCode == 13) {
                const newArray =  e.currentTarget.value;
                setProjects(oldArray => [...oldArray, newArray]);
              }
             }} 
           />
           <Dropdown.Divider/>
            {projects.map((project) => 
           <Dropdown.Item
             name='projectType'
             onClick={(e, { name }) => {
             setEmployee({ ...employee, [name]: project });
             setOpen(false);
            }}
           >
             {project}
           </Dropdown.Item>)}
          </Dropdown.Menu>
          </Form.Dropdown> */}
          <Form.Dropdown
            label="Project Type"
            placeholder='Project Type'
            name="projectType"
            multiple
            search
            selection
            onChange={(e, { name, value }) => {
              setEmployee({ ...employee, [name]: value });
            }}
            options={projectOptions}
            value={employee.projectType}
          />
        </Form.Group>
        <Form.Group>
        <Form.Input
            label="Mobile"
            required
            width='4'
            onChange={handleInputChange}
            name="mobile"
            placeholder="Employee Mobile"
            value={employee.mobile}
          />
        <Form.Input
          label="Address"
          width='12'
          onChange={handleInputChange}
          name="address"
          placeholder="Employee Address"
          value={employee.address}
        />
        
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input
            label="Date of Birth"
            required
            onChange={handleInputChange}
            name="dob"
            placeholder="Date of Birth"
            value={employee.dob}
            type="date"
          />
          <Form.Input
            label="Start Date"
            required
            onChange={handleInputChange}
            name="startDate"
            placeholder="Start Date"
            value={employee.startDate}
            type="date"
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Select
            label="Employee Type"
            onChange={(e, { name, value }) =>
              setEmployee({ ...employee, [name]: value })
            }
            name="type"
            placeholder="Employee Type"
            value={employee.type}
            options={typeOptions}
            clearable
          />
          <Form.Select
            label="Australian Residency"
            onChange={(e, { name, value }) =>
              setEmployee({ ...employee, [name]: value })
            }
            name="australianResidency"
            placeholder="Select australian residency or type in new visa type"
            value={employee.australianResidency}
            options={residency}
            search
            selection
            fluid
            allowAdditions
            additionLabel="Add Residency type"
            onAddItem={(e, { value }) => {
              setResidency([
                {
                  key: value as string,
                  text: value as string,
                  value: value as string,
                },
                ...residency,
              ]);
            }}
          />
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Input
            label="Worker ID"
            onChange={handleInputChange}
            name="workerId"
            placeholder="Worker ID"
            value={employee.workerId}
          />
          <Form.Input
            label="NBN Enable ID"
            onChange={handleInputChange}
            name="nbnEnableId"
            placeholder="NBN Enable ID"
            value={employee.nbnEnableId}
          />
          <Form.Input
            label="USI"
            onChange={handleInputChange}
            name="usi"
            placeholder="USI"
            value={employee.usi}
          />
        </Form.Group>
        <Form.Field
          label='Remark'
          control={TextareaAutosize}
          rows={1}
          onChange={handleInputChange}
          name='remark'
          placeholder='Remark'
          value={employee.remark}
        />

        <Button
          loading={submitting}
          floated="right"
          positive
          type="submit"
          content="submit"
        />
        <Button
          onClick={() => history.push("/hrmanagement/employees")}
          floated="right"
          type="button"
          content="Cancel"
        />
      </Form>
    </Segment>
  );
};

export default observer(EmployeeEditForm);
